import configureStore, { history } from 'common/configure-store';
import reducer from './reducers';

export { history };

export default configureStore({}, reducer);
